import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import { escapeRegExp } from 'lodash';

const DIVIDERS = [' vs ', ' v ', ' @ ', ' v.s. ', ' - ', ' x ', ' vs. ', ' – ', '–'];

/**
 * Finds the first instance of one of the above dividers that is surrounded
 * either side by a space, but that is not preceeded by a '/'.
 */
const dividerRegexp = new RegExp(`[^\\/](?:${DIVIDERS.map(escapeRegExp).join('|')})`, 'i');

/**
 * Use `useParticipants` over this directly as it avoids
 * unnecessary regexp invocation on every render.
 */
const getParticipantsFromEventName = (eventName = ''): EnrichedParticipants | undefined => {
  const match = eventName.match(dividerRegexp);

  if (!match || !match.index) return undefined;

  const teamA = eventName.substr(0, match.index + 1).trim();
  const teamB = eventName.substr(match.index + match[0].length).trim();

  return [{ participant: teamA }, { participant: teamB }];
};

export default getParticipantsFromEventName;
